import styled from "styled-components";

export const Loading = () => {
    return (
        <LoaderContainer>
           <svg width="60" height="60" viewBox="0 0 50 50"><circle cx="25" cy="25" r="20" fill="none" stroke="#1890ff" stroke-width="3" stroke-linecap="round" stroke-dasharray="60 120"><animateTransform attributeName="transform" type="rotate" from="0 25 25" to="360 25 25" dur="1s" repeatCount="indefinite"></animateTransform></circle></svg>
        </LoaderContainer>
    );
};


const LoaderContainer = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100%;

    svg {
        width: 60px;
        height: 60px;
    }
`;
